import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import MyChart from "../../../../Shared/MyChart";
export const Home = ()=> {
    return (
        <>
             <div className="container-fluid">
                    <div className="block-header">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                                <h2>Dashboard</h2>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href="#" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                                    </li>                            
                                    <li className="breadcrumb-item">Dashboard</li>
                                </ul>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="d-flex flex-row-reverse">
                                    <div className="page_action">
                                        {/* <button type="button" className="btn btn-dark"><i className="fa fa-download"></i> Nuevo usuario</button> */}
                                    </div>
                                    <div className="p-2 d-flex">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="panel">
                            <div className="panel-heading">
                                <strong>
                                    Panel principal (Dashboard) donde vera un resumen de como esta yendo actualmente el negocio.<br></br>Desde
                                    este apartado usted podrá visualizar un resumen de todos los movimientos como
                                    productos en agotamiento.
                                </strong>
                            </div>
                        </div>
                        <div className='title-report'>
                            Resumen
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-6 table-report'>
                            <table className="table table-stripped table-hover">
                                <tbody>
                                    <tr>
                                        <td className="text-center"><FontAwesomeIcon icon={icon({name: 'sitemap'})} /></td>
                                        <td>Categorias</td>
                                        <td id="categorias" className="text-right"><strong>12</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="text-center"><FontAwesomeIcon icon={icon({name: 'tag'})} /></td>
                                        <td>Marcas</td>
                                        <td id="marcas" className="text-right"><strong>119</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="text-center"><FontAwesomeIcon icon={icon({name: 'cube'})} /></td>
                                        <td>Productos</td>
                                        <td id="productos" className="text-right"><strong>2165</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="text-center"><FontAwesomeIcon icon={icon({name: 'user'})} /></td>
                                        <td>Clientes</td>
                                        <td id="clientes" className="text-right"><strong>1330</strong></td>
                                    </tr>

                                </tbody>
                            </table>
                            <hr></hr>
                            <table className="table table-stripped table-hover">
                                <tbody>
                                    <tr>
                                        <td className="text-center"><FontAwesomeIcon icon={icon({name: 'home'})} /></td>
                                        <td>Pedidos Generados</td>
                                        <td id="ped-gen" className="text-right"><strong>16</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="text-center"><FontAwesomeIcon icon={icon({name: 'home'})} /></td>
                                        <td>Pedidos Pendientes</td>
                                        <td id="ped-pending" className="text-right"><strong>0</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="text-center"><FontAwesomeIcon icon={icon({name: 'home'})} /></td>
                                        <td>Pedidos Enviados</td>
                                        <td id="ped-send" className="text-right"><strong>1</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="text-center"><FontAwesomeIcon icon={icon({name: 'home'})} /></td>
                                        <td>Pedidos Finalizados</td>
                                        <td id="ped-finish" className="text-right"><strong>624</strong></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-lg-6">
                            <MyChart></MyChart>
                        </div>
                    </div>
                </div>
        </>
    );
}